import { render, staticRenderFns } from "./robOrder.vue?vue&type=template&id=2efa5cc0&scoped=true&"
import script from "./robOrder.vue?vue&type=script&lang=js&"
export * from "./robOrder.vue?vue&type=script&lang=js&"
import style0 from "./robOrder.vue?vue&type=style&index=0&id=2efa5cc0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa5cc0",
  null
  
)

export default component.exports